import React from "react";
import { geometryType } from "./AddCoordinateToolBar";

export default function SavedPoint(props) {
  if (props.point.type !== geometryType.POINT) return null;
  return (
    <span className="geometryLabel">
      {`${props.point.roadNo} ${props.point.roadName} ${
        props.point.slk
          ? props.point.slk
          : `[${props.point.latitude},${props.point.longitude}]`
      }`}
    </span>
  );
}
